import React, { useState, useEffect } from "react";
import { Field, formValueSelector, FieldArray } from "redux-form";
import { FormGroup, Label } from "reactstrap";
import { connect } from "react-redux";
import Repeater from "../../../system/fields/Repeater";
import DatePickerInput from "../../../system/fields/DatePicker";
import * as validations from "../../../system/utils/Validation";
import TextInput from "../../../system/fields/TextInput";
import Switch from "../../../system/fields/Switch";

import SelectDropdown from "../../../system/fields/SelectDropdown";

const selector = formValueSelector("DealForm");

const DateComponent = ({ fields, dateType }) => {
  const [type, setType] = useState(dateType === "month" ? "month" : "range");

  return (
    <React.Fragment>
      {fields.map((date, index) => (
        <React.Fragment>
          <div key={index} className={"row"}>
            <React.Fragment>
              <FormGroup className='col-12 col-sm-3'>
                <Label htmlFor='email'>
                  {type === "month" ? "Month Duration" : "Date From"}
                </Label>
                <Field
                  name={`${date}.date_from`}
                  dateFormat={type === "month" ? "MMMM yyyy" : "dd/MM/yyyy"}
                  fieldName={"date_from"}
                  dateType={type}
                  placeholder='Select date from'
                  component={DatePickerInput}
                  type='text'
                  className='form-control'
                  validate={validations.required}
                />
              </FormGroup>
              <FormGroup
                className='col-12 col-sm-3'
                style={{ display: type === "month" && "none" }}
              >
                <Label htmlFor='email'>Date To</Label>
                <Field
                  name={`${date}.date_to`}
                  dateFormat='dd/MM/yyyy'
                  fieldName={"date_to"}
                  dateType={type}
                  placeholder='Select date to'
                  component={DatePickerInput}
                  dateIndex={index}
                  type='text'
                  className='form-control'
                  validate={validations.required}
                />
              </FormGroup>
            </React.Fragment>

            <FormGroup className='col-10 col-sm-2'>
              <Label htmlFor='email'>Price Per Person</Label>
              <Field
                name={`${date}.price`}
                component={TextInput}
                placeholder='Price Per Person'
                type='text'
                validate={validations.required}
              />
            </FormGroup>

            <FormGroup className='col-10 col-sm-2'>
              <Label>Display as single month</Label>
              <Field
                name={`${date}.hide_range`}
                component={Switch}
                type='text'
              />
            </FormGroup>

            <FormGroup
              className={"col-2 d-flex justify-content-center align-items-end"}
            >
              <button
                type={"button"}
                className={"btn btn-danger"}
                onClick={() => fields.remove(index)}
              >
                Delete
              </button>
            </FormGroup>
          </div>
          <hr />
        </React.Fragment>
      ))}
      <button
        type='button'
        className={"mt-2 btn btn-secondary"}
        onClick={() => {
          // setType("range");
          fields.push({});
        }}
      >
        Add Date
      </button>
      <button
        type='button'
        className={"mt-2 btn btn-secondary"}
        style={{ marginLeft: "3em" }}
        onClick={() => {
          setType(type === "month" ? "range" : "month");
        }}
      >
        {type === "month" ? "Change to Range" : "Change to Month"}
      </button>
    </React.Fragment>
  );
};

class Dates extends React.Component {
  constructor(props, date, index, fields) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: true };
  }
  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  remove(index) {
    const result = window.confirm("Are you sure you want to remove this row?");
    if (result) {
      this.props.fields.remove(index);
    }
  }

  render() {
    const index = this.props.index;
    const { date, dateType } = this.props;

    return (
      <Repeater key={this.props.index}>
        <div className='toolbar'>
          <i
            className='far fa-trash-alt'
            onClick={() => this.remove(this.props.index)}
          />
        </div>

        <div className='top-field'>
          <Field
            name={`${date}.airport`}
            type='text'
            component={SelectDropdown}
            options={this.props.airports}
            valueKey='id'
            labelKey='airport_code'
            placeholder='Select an Airport'
          />
        </div>

        {this.props.airport !== "" && (
          <div className='top-field'>
            <FieldArray
              name={`${date}.dates`}
              dateType={this.props.dateType}
              component={DateComponent}
              dispatch={this.props.dispatch}
            />
          </div>
        )}
      </Repeater>
    );
  }
}

const DatesWrapper = connect((state, props) => ({
  airport: selector(state, `${props.date}.airport`),
}))(Dates);

export default DatesWrapper;



// WEBPACK FOOTER //
// ./src/containers/Deals/components/Dates.jsx